export const webEmbedTab = {
  scope: {
    title: "What should your site search?",
    only: "Only",
    thisListing: "this listing",
    hint: "Recommended if you paste the code on this accommodation's page. Turn it off to let the search show all your accommodations.",
  },
  where: {
    title: "Where should the accommodations appear?",
    hint: 'The search bar looks the same in all three cases. What changes is what happens when the visitor taps "Search".',
    ariaLabel: "Where availability appears",
    ownFields: {
      name: "I already have my own search bar",
      hint: "We won't add our bar: use your own fields and hand us the search",
    },
  },
  modes: {
    overlay: {
      name: "Floating over your site",
      tag: "Recommended",
      desc: "The list opens in a window above your page and closes with the X. Your site doesn't move: the visitor returns exactly where they were.",
    },
    inline: {
      name: "Inside your page",
      desc: "The list appears on your own site, like one more section: it scrolls with the rest of the content and there's nothing to close. You choose where on the page it shows.",
    },
    tab: {
      name: "In a new tab",
      desc: "The bar lives on your site and, on search, the booking continues in another tab. It's the simplest option, but the visitor takes the booking elsewhere.",
    },
  },
  modeNote: {
    overlay: "The search bar keeps a fixed height and doesn't change: the list and the whole booking process happen in the floating window, with its own scroll.",
    inline: "Here the only thing that grows is the list section, which is exactly what you asked to grow. The search bar still takes up the same space and the calendar opens above it, without shifting anything.",
    tab: "Only the bar is embedded. Everything else happens in the booking engine, in a separate tab.",
  },
  webs: {
    bahia: "Site with a hero",
    cala: "Minimalist site",
  },
  fondos: {
    white: "White (default)",
    transparent: "Transparent · adopts your site's",
  },
  appearance: {
    title: "Appearance",
    buttonColor: "Button color",
    background: "Search bar background",
    language: "Language",
  },
  preview: {
    title: "How it looks on a website",
    hint: "A sample site with your search bar in place. It's the real widget: pick dates and tap Search to see how it behaves.",
    openFull: "Open at full size",
    testIn: "Test on",
    testInAriaLabel: "Sample website",
    missingUuid: "The account identifier is missing to generate the widget.",
    fakeUrl: "your-site.com",
    iframeTitle: "Preview of the widget on a sample website",
  },
  guide: {
    title: "How to add it to your site",
    hint: 'Works on any page: HTML, WordPress ("Custom HTML" block), Wix, Squarespace, Shopify… Nothing to install.',
    warn: "<b>If your site is Wix, Squarespace or Shopify</b>, two things: in the <b>editor</b> the code block always looks empty —it only works in \"Preview\" or once published—, and since those platforms wrap the search bar in a box of their own, <b>everything happens inside that box</b>: the calendar and the list of accommodations. So <b>stretch it to about 900 px tall</b> in the editor; if it's too short, the calendar gets cut off. We handle the rest: don't change the code.",
    missingUuid: "The account identifier is missing to generate the code.",
    copy: "Copy",
    copied: "Copied",
    saveReload: "Save and reload your site",
  },
  steps: {
    script: {
      title: "Paste this where you want the search bar to appear",
      titleOwn: "Paste this once, anywhere on the page",
      hint: "Right where you want the date bar: the hero, a strip below the menu, a sidebar…",
      hintOwn: "It draws nothing on its own: it gets the booking ready for your own form.",
      after: "The bar keeps a fixed height and won't resize, so it won't throw off your layout.",
    },
    target: {
      title: "Paste this slot where you want the list to appear",
      hint: 'Usually a section of its own below the hero, with your heading above it ("Availability", "Our homes"…).',
      after: "Until someone searches, that slot takes up no space. If you leave it out, the list appears right below the search bar.",
    },
    api: {
      title: "Connect your fields to the search",
      hint: "You keep your design, but the calendar can be ours: the one that shows each night's price, the minimum stay and the booked days.",
      after: "If you prefer your own date fields, that works too: pass us the dates in YYYY-MM-DD format straight to WACheckin.search().",
    },
  },
  toasts: {
    manualCopySummary: "Manual copy",
    manualCopyDetail: "Your browser didn't allow copying automatically. The code is already selected.",
  },
};
